export const allTags = [
    'Intro', 'Social', 'Social Mod', 'Mod', 'Mod+', 'Pacy', 'Race', 'Time-trial',
    'Women-only', 'Virtual', 'Triathlon', 'Gravel', 'MTB', 'Social event',
    'Flexibility', 'Meeting', 'Swim', 'Run']

export const defaultLocations = [
    ['Milford Railway Station, Milford, Godalming GU8 5AD', [-0.651896, 51.171284]],
    ['Weyhill Car Park, Haslemere GU27 1DA', [-0.709146, 51.088272]],
    ['The Merry Harriers, Hambledon, GU8 4DR', [-0.620312, 51.137770]],
    ['Rodborough Common Car Park, Milford, Godalming GU8 5RY', [-0.651896, 51.171284]],
    ['The Star Inn, Witley, Godalming GU8 5LU', [-0.646894, 51.148533]],
    ['Secrett\'s Farm Shop, Godalming GU8 5HU', [-0.651896, 51.171284]],
    ['Bel & The Dragon, Jumps Rd, Farnham GU10 2LD', [-0.755217, 51.146194]]
]